import { useQuery } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

export const reportingPaymentsBySessionAPI = async (params: {
  sessionId: string;
  format: string;
}) => {
  const response = await baseAPI.get<string>('/reporting/payments-by-session', {
    params,
    responseType: 'text',
  });
  return response.data;
};

export const useReportingPaymentsBySession = (params: {
  sessionId: string;
  format: string;
}) => {
  return useQuery({
    queryKey: [KEYS.PAYMENTS_BY_SESSION, params.sessionId, params.format],
    queryFn: () => reportingPaymentsBySessionAPI(params),
    enabled: !!params.sessionId && !!params.format,
  });
};
